/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenTabletHIcon64Regular = forwardRef('TechScreenTabletHIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M17.5 43a1.5 1.5 0 0 0 0 3h29a1.5 1.5 0 0 0 0-3h-29Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 10C10.701 10 6 14.701 6 20.5v23C6 49.299 10.701 54 16.5 54h31C53.299 54 58 49.299 58 43.5v-23C58 14.701 53.299 10 47.5 10h-31ZM9 20.5a7.5 7.5 0 0 1 7.5-7.5h31a7.5 7.5 0 0 1 7.5 7.5v23a7.5 7.5 0 0 1-7.5 7.5h-31A7.5 7.5 0 0 1 9 43.5v-23Z" })));
});
